let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gJh6i")).then(() => parcelRequire('9bTQb'));